import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Flex,
  Heading,
  Text,
  DropdownMenuItem,
  DropdownMenuSeparator,
  IconButton,
  Button
} from '@sparrowengg/twigs-react';
import Surveysparrow from 'commons/icons/surveysparrow';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import {
  ArrowLeftIcon,
  UserCircleIcon,
  UserIcon
} from '@sparrowengg/twigs-react-icons';
import {
  authValuesForLogout,
  authenticateUserValues,
  product
} from 'commons/constants';
import { developerDocs } from 'commons/constants';
import Exit from 'commons/icons/Exit';
import ExternalLink from 'commons/icons/ExternalLink';
import RedirectIcon from 'commons/icons/redirect';

const Navbar = ({
  showPreviousBtn,
  previousBtnHandler
}: {
  showPreviousBtn?: boolean;
  previousBtnHandler?: () => void;
}) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const domain = `.${window.location.hostname
    ?.split('.')
    ?.slice(-2)
    ?.join('.')}`;
  const productURL = `https://${
    cookie.get(authenticateUserValues.LOGIN_DOMAIN) ?? ''
  }/`;

  const handleNavigation = (url: string) => {
    window.open(url, '_blank');
  };

  const handleLogOut = () => {
    authValuesForLogout?.forEach((currentCookie) =>
      cookie.remove(currentCookie, {
        path: '/',
        domain: domain
      })
    );
    cookie.remove(authenticateUserValues.TOKEN);
    setTimeout(() => window.location.replace(`${developerDocs}`), 1000);
  };

  return (
    <Flex
      justifyContent="space-between"
      css={{
        padding: '$8 $12',
        borderBottom: '$borderWidths$xs solid $neutral200'
      }}
    >
      <Flex alignItems="center" gap="$6">
        {showPreviousBtn ? (
          <IconButton
            icon={<ArrowLeftIcon />}
            variant="ghost"
            color="secondary"
            size="lg"
            onClick={() => {
              navigate('/');
              previousBtnHandler && previousBtnHandler();
            }}
          />
        ) : null}
        <Flex
          onClick={() => navigate('/')}
          alignItems="center"
          css={{ cursor: 'pointer' }}
        >
          <Surveysparrow size={24} color="#4E596C" />
          <Heading size="h6" css={{ marginLeft: '$3', color: '$secondary600' }}>
            AppNest
          </Heading>
        </Flex>
      </Flex>
      <Flex alignItems="center">
        <Button
          variant="ghost"
          color="default"
          size="lg"
          rightIcon={<RedirectIcon />}
          onClick={() =>
            window.open('https://developers.salesparrow.com/appnest', '_blank')
          }
        >
          AppNest Help Guide
        </Button>
        {productURL && productURL?.includes(`${product}`) && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <IconButton
                variant={'ghost'}
                size={'lg'}
                color={'secondary'}
                icon={<UserCircleIcon />}
              />
            </DropdownMenuTrigger>
            <DropdownMenuContent
              onCloseAutoFocus={(event) => event.preventDefault()}
              sideOffset={2}
              css={{
                minWidth: 180,
                marginRight: '$8'
              }}
            >
              <DropdownMenuItem>
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  gap="$2"
                  onClick={() =>
                    handleNavigation(productURL + 'settings/profile-settings')
                  }
                  css={{
                    cursor: 'pointer'
                  }}
                >
                  <UserIcon size={20} />
                  <Text
                    css={{
                      color: '$neutral800'
                    }}
                  >
                    Profile Settings
                  </Text>
                </Flex>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  gap="$2"
                  onClick={() => handleNavigation(productURL)}
                  css={{
                    cursor: 'pointer'
                  }}
                >
                  <ExternalLink />
                  <Text
                    css={{
                      color: '$neutral800'
                    }}
                  >
                    Go to Account
                  </Text>
                </Flex>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  gap="$4"
                  onClick={() => handleLogOut()}
                  css={{
                    cursor: 'pointer',
                    color: '$neutral800'
                  }}
                >
                  <Exit color="red" />
                  <Text size="md">Logout</Text>
                </Flex>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </Flex>
    </Flex>
  );
};
export default Navbar;
